import script from "./AdventurerIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventurerIcon.vue?vue&type=script&setup=true&lang=js"

import "./AdventurerIcon.vue?vue&type=style&index=0&id=12c531d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c531d7"]])

export default __exports__